import {ManagedStream} from '@quobis/sippojs';
import React, {ReactElement} from 'react';

interface IProps {
	managedStream: ManagedStream;
}

export default function VideoComponent(props: IProps): JSX.Element {

	const getVideo = (): ReactElement => <video autoPlay playsInline ref={ (element) => {
		if (element && props.managedStream.mediaStream) {
			element.srcObject = props.managedStream.mediaStream;
		}
	}}
	/>;

	return (
		<div >
			{ getVideo() }
		</div>
	);
}
